import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { ProgressCardComponent } from '../../ui/progress-card/progress-card.component';
import { FaceAnalysisCardComponent } from '../../ui/face-analysis-card/face-analysis-card.component';
import { BandScaleComponent } from '../../ui/band-scale/band-scale.component';
import { ProgressCardVM } from '../../results-vm';
import { BAND_CONFIG } from '../../results-placeholders';
import { ImprintPanelVM } from './imprint-vm';

/** paid-1 — Hormonal Imprint detail. */
@Component({
  selector: 'app-imprint-panel',
  standalone: true,
  imports: [CommonModule, TranslatePipe, ProgressCardComponent, FaceAnalysisCardComponent, BandScaleComponent],
  templateUrl: './imprint-panel.component.html',
})
export class ImprintPanelComponent {
  @Input() vm!: ImprintPanelVM;
  @Output() goPaywall = new EventEmitter<void>();
  @Input() active = false;
  @Input() progress: ProgressCardVM | null = null;

  /** wordfirst sec 2/3 — 3-level bar config for the hero verdict. */
  readonly bandConfig = BAND_CONFIG.imprint;

  pct(v: number, max = 100): number {
    return Math.max(0, Math.min(100, (v / max) * 100));
  }
}
